<ul class="timeline">
    <li class="timeline-line mt-4"></li>
    <li class="timeline-item" *ngFor="let activity of logs">
        <div class="timeline-badge">
            <span class="bg-primary bg-lighten-4" data-toggle="tooltip" data-placement="right"
                title="{{activity.user?.name}} {{activity.user?.lastName}}">
                <img src="{{activity.user?.urlImage}}" *ngIf="activity.user?.urlImage != null" class="avatar"
                    alt="avatar" width="40">
                <img src="../../../../assets/img/avatar.png" *ngIf="activity.user?.urlImage == null" class="avatar"
                    alt="avatar" width="40">
            </span>
        </div>
        <div class="activity-list-text">
            <h6 class="mb-1">
                <span>{{activity.activity}}</span>
                <span class="float-right grey font-italic font-small-2">{{activity.date | date:'dd/MM/yyyy
                    HH:mm'}}</span>
            </h6>
            <p class="mt-0 mb-2 font-small-3">{{activity.activity}}</p>
            <div class="notification-note" *ngIf="activity.typeObj == 'PROCESS'">
                <div class="p-1 pl-2">
                    <a href="/process/view/{{activity.idObj}}"><span class="text-bold-500">Processo:
                            {{activity.nameObj}}</span></a>
                </div>
            </div>
        </div>
    </li>
</ul>